import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { useEngagementLinkStatus } from "../../hooks/engagement_link/use_engagement_link_status";
import { usePopulateLinkedEngagementFields } from "../../hooks/engagement_link/use_populate_linked_engagement_fields";

export const RestoreEngagementLinkButton = () => {
  const restoreEngagementValues = usePopulateLinkedEngagementFields();
  const { hasAnyLinkedValue, hasAnyValueChanged, isPermittedToRestore } = useEngagementLinkStatus();
  const { t } = useTranslation("activities", { keyPrefix: "form.engagementLink" });

  if (!hasAnyLinkedValue || !hasAnyValueChanged) {
    return null;
  }

  return (
    <Tooltip
      content={<Typography variant="bodyRegular">{t("insufficientPermissions")}</Typography>}
      disabled={isPermittedToRestore}
    >
      <Button
        kind="secondary"
        icon="history"
        small
        onClick={() => restoreEngagementValues({ skipOtherSources: true })}
        text={t("restoreAll")}
        disabled={!isPermittedToRestore}
      />
    </Tooltip>
  );
};
